import { useEffect, useState } from "react";
import { __Currency } from "../../../_core/core";

import "./Bet.options.styles.css";

interface BetOptionInterface {
  isMoney: boolean;
  options: any[];
  title: string;
  defaultOption?: number; //default index
  onChange: Function;
  isDisabled: boolean;
  selectedOption: any;
}

const BetOption = ({
  isMoney,
  title,
  defaultOption,
  options,
  onChange,
  isDisabled,
  selectedOption,
}: BetOptionInterface) => {
  const _selectedOption = options.findIndex((el: any) => selectedOption === el);

  const [currentOption, setCurrentOption] = useState<number>(selectedOption);

  const nextVal = () => {
    if (currentOption + 1 >= options.length) return;
    setCurrentOption((val) => val + 1);
    let option = options[currentOption + 1];
    onChange(option);
  };

  const prevVal = () => {
    if (currentOption < 1) return;
    setCurrentOption((val) => val - 1);
    let option = options[currentOption - 1];
    onChange(option);
  };

  const formatLabelValue = (val: any) => {
    if (val === 1) return title;
    else return title + "s";
  };

  useEffect(() => {
    if (selectedOption) {
      setCurrentOption(_selectedOption);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOption]);

  return (
    <div className="options-widget-container">
      <button
        className="options-btn"
        onClick={() => prevVal()}
        disabled={currentOption === 0 || isDisabled}
      >
        <i className="fa fa-minus"></i>
      </button>
      <span className="options-label">
        {isMoney
          ? title + ": " + __Currency.format(options[currentOption])
          : ""}
        {!isMoney
          ? options[currentOption] +
            " " +
            formatLabelValue(options[currentOption])
          : ""}
      </span>
      <button
        className="options-btn"
        onClick={() => nextVal()}
        disabled={currentOption + 1 >= options.length || isDisabled}
      >
        <i className="fa fa-plus"></i>
      </button>
    </div>
  );
};

export default BetOption;
